/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: '',
    // Relative to /src/views
    view: 'Main'
  },
  {
    path: '/user/:id',
    view: 'User'
  },
  {
    path: '/device/:id',
    view: 'Device'
  },
  {
    path: '/home/:id',
    view: 'Home'
  },
  {
    path: '/login',
    name: 'Login',
    view: 'Login'
  },
  {
    path: '/logout',
    view: 'Login'
  },
  {
    path: '/formulations',
    view: 'Formulations'
  },
  {
    path: '/formulation/:id',
    view: 'Formulation'
  }
]
